import { Box, Skeleton, Stack } from '@machobear/design-system'
import { responsiveBox } from './event-skeleton.css'

export const EventsSkeleton = () => {
  return (
    <Stack space="small">
      <Box className={responsiveBox} paddingTop="small" flexDirection="column">
        <Stack space="xsmall">
          <Skeleton.Shape height={80} />
          <Skeleton.Shape width={95} height={20} />
        </Stack>
      </Box>
      <Box paddingY="medium">
        <Stack align="right" space="xxsmall">
          <Box width="full" className={responsiveBox}>
            <Skeleton.Shape height={80} />
          </Box>
          <Skeleton.Shape width={95} height={20} />
        </Stack>
      </Box>
      <Box
        className={responsiveBox}
        paddingBottom="small"
        display="flex"
        flexDirection="column"
        width="full"
      >
        <Stack space="xxsmall">
          <Skeleton.Shape height={80} />
          <Skeleton.Shape width={95} height={20} />
        </Stack>
      </Box>
    </Stack>
  )
}
